import { Slot } from "@radix-ui/react-slot";
import type { ComponentProps, FC, HTMLProps } from "react";

import { Icon } from "../../components";
import { cn } from "../../utils";

export interface FieldRowProps extends HTMLProps<HTMLLabelElement> {
  icon?: ComponentProps<typeof Icon>["icon"];
  asChild?: boolean;
}

// TODO: Modify `FieldRow` and borderless fields to better support errors:
// - If there is an error, icon color should be red
// - If there is an error, placeholder text should be destructive
export const FieldRow: FC<FieldRowProps> = ({ children, className, icon, asChild, ...props }) => {
  const Comp = asChild ? Slot : "label";

  return (
    <Comp {...props}>
      <div className={cn("flex min-h-12 items-start gap-4 py-1 px-6", className)}>
        {icon && (
          <FieldRowPrefix className="size-6 text-base justify-center">
            <Icon icon={icon} />
          </FieldRowPrefix>
        )}
        {children}
      </div>
    </Comp>
  );
};

export const FieldRowPrefix: FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => (
  <span className={cn("flex flex-none items-center mt-2 text-muted-foreground text-xs", className)}>{children}</span>
);
